import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PAGES_AND_PATHS } from '../../../../constants/pages-and-paths';
import { ToastrService } from 'ngx-toastr';
import { BusinessProfilesHttpService } from '../../../../services/http-services/business-profiles/business-profiles-http.service';
import { DigitRegex, PlayRoomUnits, Units, UnitsForCake } from '../../../../constants/general-variables';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-price-list-category-item-create-or-edit',
  templateUrl: './price-list-category-item-create-or-edit.component.html',
})
export class PriceListCategoryItemCreateOrEditComponent implements OnInit {
  createOrEditPriceListItemForm!: FormGroup;
  formTriedToSubmit = false;
  urlParams = {
    companyId: null,
    categoryId: null,
    itemId: null,
  };
  imageUrls: any[] = [];
  businessProfile: any;
  deletedImagesIds: number[] = [];
  initialData: any;
  units = Units;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  unitsOfCat: any[] = PlayRoomUnits;
  unitType: any;

  constructor(private formBuilder: FormBuilder,
    private toastService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private businessProfilesHttpService: BusinessProfilesHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.activatedRoute.params.subscribe((res: any) => {
      this.urlParams.companyId = res.id;
      this.urlParams.categoryId = res.categoryId;
      this.urlParams.itemId = res.itemId;
      if (this.urlParams.categoryId) {
        this.createOrEditPriceListItemForm.controls.item_category_id.patchValue(this.urlParams.categoryId);
      }
      this.getBusinessProfile();
    });
  }

  buildForm(): void {
    this.createOrEditPriceListItemForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      unit: ['', Validators.required],
      quantity: ['', Validators.required],
      price: ['', [Validators.required, Validators.pattern(DigitRegex)]],
      down_payment: ['', [Validators.required, Validators.pattern(DigitRegex)]],
      images: [null, Validators.required],
      deleted_images_ids: [[]],
      item_category_id: ['', Validators.required]
    });
  }

  getPriceListItem(): void {
    const { categoryId, ...rest } = this.urlParams;
    this.businessProfilesHttpService.getPriceListItem(rest).then(res => {
      const { cake_properties, ...resData } = res.data;
      this.unitType = res.data.category;
      this.initialData = { cakeProperties: cake_properties, resData };
      this.createOrEditPriceListItemForm.patchValue(resData);
      this.initialData.cakeProperties?.forEach((floor: any, floorIndex: number) => {
        this.addNewFloor();
        floor.forEach((flavour: any) => {
          this.addNewFlavoursField(floorIndex, flavour);
        });
      });
      this.imageUrls = res.data.images.map((item: any) => {
        return { fullPath: item.full_path, id: item.id, file: undefined };
      });
      if (this.businessProfile.business_category_id === 6) {
        this.createOrEditPriceListItemForm.controls.number_of_floors.patchValue(res.data.number_of_floors ? res.data.number_of_floors : 1);
        this.createOrEditPriceListItemForm.controls.number_of_floors.valueChanges.subscribe(value => {
          this.updateFloors(value);
        });
      }
      this.createOrEditPriceListItemForm.controls.quantity.patchValue(resData.quantity ? Number(resData.quantity) : '');
    });
  }

  get selectedTypeName(): string {
    const selectedId = this.unitType?.type;
    const found = this.unitsOfCat.find(t => t.short === selectedId);
    return found ? found.short : 'Nije izabrano';
  }

  getBusinessProfile(): void {
    this.businessProfilesHttpService.getSingleBusiness({ companyId: this.urlParams.companyId }).then(res => {
      this.businessProfile = res.data;
      console.log('this.businessProfile', this.businessProfile)
      if (this.businessProfile.business_category_id === 6) {
        this.createOrEditPriceListItemForm.addControl('min_quantity', this.formBuilder.control('', Validators.required));
        this.createOrEditPriceListItemForm.addControl('max_quantity', this.formBuilder.control('', Validators.required));
        this.createOrEditPriceListItemForm.addControl('cake_properties', this.formBuilder.array([], Validators.required));
        this.createOrEditPriceListItemForm.addControl('number_of_floors', this.formBuilder.control(1, [Validators.required, Validators.pattern(DigitRegex)]));
      }
      if (this.businessProfile.business_category_id === 6 || this.businessProfile.business_category_id === 3) {
        this.units = UnitsForCake;
      }
      (this.businessProfile.business_category_id === 2 || this.businessProfile.business_category_id === 4 || this.businessProfile.business_category_id === 5)
        ? this.createOrEditPriceListItemForm.controls.quantity.setValidators([Validators.required])
        : this.createOrEditPriceListItemForm.controls.quantity.clearValidators();

      (this.businessProfile.business_category_id !== 1)
        ? this.createOrEditPriceListItemForm.controls.unit.setValidators([Validators.required])
        : this.createOrEditPriceListItemForm.controls.unit.clearValidators();

      this.createOrEditPriceListItemForm.controls.unit.updateValueAndValidity();
      this.createOrEditPriceListItemForm.controls.quantity.updateValueAndValidity();
      if (this.urlParams.itemId) {
        this.getPriceListItem();
      } else if (this.businessProfile.business_category_id === 6) {
        this.updateFloors(1);
        this.createOrEditPriceListItemForm.controls.number_of_floors.valueChanges.subscribe(value => {
          this.updateFloors(value);
        });
      }
    });
  }

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const selectedFiles = Array.from(input.files);
      if (selectedFiles.length > 50 - this.imageUrls.length) {
        this.toastService.warning('Neke od slika nece biti uploadovane zato sto ste selektovali vise slika od broja slobodnih slotova, maksimalno mozete dodati 5 slika');
      }
      selectedFiles.forEach(file => {
        if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
          this.toastService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
          return;
        } else if (file?.size > 10485760) {
          this.toastService.warning(`Slika ${file.name} je veća od 10MB.`);
          return;
        } else if (this.imageUrls.length < 50) {
          this.imageUrls.push({ fullPath: URL.createObjectURL(file), id: undefined, file });
        }
      });
      this.createOrEditPriceListItemForm.controls.images.patchValue(this.imageUrls);
      if (this.fileInput) {
        this.fileInput.nativeElement.value = '';
      }
    }
  }

  removeAllImages(): void {
    this.imageUrls.forEach((image: any) => {
      if (image.id) {
        this.deletedImagesIds.push(image.id);
      }
    });
    this.imageUrls = [];
    this.createOrEditPriceListItemForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
    this.createOrEditPriceListItemForm.controls.images.patchValue(null);
  }

  removeSingleImage(imageURL: any): void {
    const imageIndex = this.imageUrls.findIndex((imgUrl: any) => {
      return imgUrl.fullPath === imageURL.fullPath;
    });
    if (imageIndex !== -1) {
      if (imageURL.id) {
        this.deletedImagesIds.push(imageURL.id);
      }
      this.imageUrls.splice(imageIndex, 1);
      this.createOrEditPriceListItemForm.controls.deleted_images_ids.patchValue(this.deletedImagesIds);
      this.createOrEditPriceListItemForm.controls.images.patchValue(this.imageUrls.length ? this.imageUrls : null);
    }
  }

  get cakeProperties(): FormArray {
    return this.createOrEditPriceListItemForm.get('cake_properties') as FormArray;
  }

  getFlavoursArray(floorIndex: number): FormArray {
    return this.cakeProperties.at(floorIndex).get('flavours') as FormArray;
  }

  getFlavoursField(floorIndex: number, flavourIndex: number): any {
    const flavoursArray = this.cakeProperties.at(floorIndex).get('flavours') as FormArray;
    return flavoursArray.at(flavourIndex);
  }

  addNewFloor(): void {
    const floor = this.formBuilder.group({
      flavours: this.formBuilder.array([], Validators.required)
    });
    this.cakeProperties.push(floor);
  }

  updateFloors(numberOfFloors: number): void {
    const currentFloors = this.cakeProperties?.length;

    if (numberOfFloors > currentFloors) {
      for (let i = currentFloors; i < numberOfFloors; i++) {
        if (this.initialData?.cakeProperties[i]) {
          this.addNewFloor();
          this.initialData?.cakeProperties[i].forEach((flavour: any) => {
            this.addNewFlavoursField(i, flavour);
          });
        } else {
          this.addNewFloor();
          this.addNewFlavoursField(i);
        }
      }
    } else if (numberOfFloors < currentFloors) {
      for (let i = currentFloors; i > numberOfFloors; i--) {
        this.cakeProperties.removeAt(i - 1);
      }
    }
  }

  addNewFlavoursField(floorIndex: number, value = ''): void {
    const flavourObj = this.formBuilder.group({
      value: [value, Validators.required]
    });
    const flavoursArray = this.cakeProperties.at(floorIndex).get('flavours') as FormArray;
    flavoursArray.push(flavourObj);
  }

  removeFlavourField(floorIndex: number, flavourIndex: number): void {
    const flavoursArray = this.cakeProperties.at(floorIndex).get('flavours') as FormArray;
    if (flavoursArray.length > 1) {
      flavoursArray.removeAt(flavourIndex);
    } else {
      flavoursArray.removeAt(flavourIndex);
      this.addNewFlavoursField(floorIndex);
    }

  }

  submitCreateOrEditPriceListItemForm(): void {
    this.formTriedToSubmit = true;
    console.log(this.createOrEditPriceListItemForm.value);
    if (this.createOrEditPriceListItemForm.valid) {
      const formData: FormData = new FormData();
      for (const key in this.createOrEditPriceListItemForm.value) {
        if (Array.isArray(this.createOrEditPriceListItemForm.value[key])) {
          if (key === 'images') {
            this.createOrEditPriceListItemForm.value[key].forEach((element: any, index: number) => {
              formData.append(`images[${index}][position]`, (index + 1).toString());
              (element.id)
                ? formData.append(`images[${index}][id]`, element.id.toString())
                : formData.append(`images[${index}][file]`, element.file);
            });
          } else if (key === 'cake_properties') {
            this.createOrEditPriceListItemForm.value[key].forEach((floor: any, floorIndex: number) => {
              floor.flavours.forEach((flavour: any, flavourIndex: number) => {
                if (flavour.value) {
                  formData.append(`cake_properties[${floorIndex}][${flavourIndex}]`, flavour.value);
                }
              });
            });
          } else {
            this.createOrEditPriceListItemForm.value[key].forEach((element: any) => {
              formData.append(`${key}[]`, element);
            });
          }
        } else if (this.createOrEditPriceListItemForm.value[key] !== null && this.createOrEditPriceListItemForm.value[key] !== undefined) {
          formData.append(key, this.createOrEditPriceListItemForm.value[key]);
        }
      }
      this.urlParams.itemId
        ? this.businessProfilesHttpService.putPriceListItem(this.urlParams, formData).then(res => {
          this.deletedImagesIds = [];
          this.createOrEditPriceListItemForm.controls.deleted_images_ids.patchValue([]);
          this.toastService.success(res.message);
          this.router.navigate(['/business-profile', this.urlParams.companyId, 'price-list-category', this.urlParams.categoryId]);
        }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
          Object.values(error.errors).forEach(error => this.toastService.error(error));
        })
        : this.businessProfilesHttpService.postPriceListItem(this.urlParams, formData).then(res => {
          this.deletedImagesIds = [];
          this.createOrEditPriceListItemForm.controls.deleted_images_ids.patchValue([]);
          this.toastService.success(res.message);
          this.router.navigate(['/business-profile', this.urlParams.companyId, 'price-list-category', this.urlParams.categoryId]);
        }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
          Object.values(error.errors).forEach(error => this.toastService.error(error));
        });
    }
  }
}
